import { render, staticRenderFns } from "./InscripcionAitana.vue?vue&type=template&id=406fb621"
import script from "./InscripcionAitana.vue?vue&type=script&lang=js"
export * from "./InscripcionAitana.vue?vue&type=script&lang=js"
import style0 from "./InscripcionAitana.vue?vue&type=style&index=0&id=406fb621&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports